<template>
	<AppSelect
		outlined
		hide-details
		item-value="id"
		item-text="provider_name"
		@change="onChange"
		placeholder="Select integration"
		:value="selectedProviderId"
		:items="analyticsProviders"
		:menu-props="{ bottom: true, offsetY: true, contentClass: 'apps-select-empty-state-menu' }"
	>
		<template v-slot:selection="{ item }">
			<div v-if="item" class="selected-app flex-centerize py-[10px]">
				<div class="w-[25px] h-[25px] grid rounded-lg shadow-md border border-[#DFE4EF] mr-[15px]">
					<v-img class="place-self-center" :src="item.icon" :width="15" />
				</div>
				<div class="text-[14px] font-normal">{{ item.provider_name }}</div>
			</div>
		</template>
		<template v-slot:item="{ item }">
			<div v-if="item" class="selection-row flex-centerize py-[10px]">
				<div class="w-[48px] h-[48px] grid rounded-lg shadow-md border border-[#DFE4EF] mr-[15px] bg-white z-10">
					<v-img class="place-self-center" :src="item.icon" :width="20" />
				</div>
				<div class="text-[14px] font-normal">{{ item.provider_name }}</div>
			</div>
		</template>
	</AppSelect>
</template>

<script>
import { useAnalyticsProvidersArray } from '@/store/modules/analyticsProvider/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'ServiceSelect',
	props: {
		selectedProviderId: { type: Number },
	},
	computed: {
		...mapGettersShorthand({ useAnalyticsProvidersArray }),
		analyticsProviders() {
			return this.useAnalyticsProvidersArray;
		},
	},
	methods: {
		onChange(provider) {
			this.$emit('onProviderSelected', provider);
		},
	},
};
</script>

<style lang="scss"></style>
